import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { ArtWorkInterface } from "../../utils/interfaces/art-work.interface";
import { ImageModalComponent } from "../../components/image-modal/image-modal.component";
import {ResponsiveImageDirective} from "../../utils/directives/responsive-image.directive";

@Component({
  selector: 'app-projects',
  standalone: true,
  imports: [
    ImageModalComponent,
    ResponsiveImageDirective
  ],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss'
})
export class ProjectsComponent {
  selectedProject: ArtWorkInterface | null = null;
  isModalVisible = false;
  projects: ArtWorkInterface[] = [];

  constructor(private sanitizer: DomSanitizer) {
    this.projects =  [
      {
        title: "Ignacy Jan Paderewski",
        description: this.sanitizeHtml(`
          <p>18 x 13 cm</p>
          <p>gips ceramiczny polichromowany</p>
          <p><b>2023</b></p>
          <p>Project konkursowy popiersia Ignacego Jana Paderewskiego w Narodowym Muzeum Morskim w Gdańsku</p>
          <p><small>fot. Piotr Mastalerz</small></p>
        `),
        images: ["images/paderewski/paderewski_1.webp", "images/paderewski/paderewski_2.webp", "images/paderewski/paderewski_3.webp", "images/paderewski/paderewski_4.webp", "images/paderewski/paderewski_5.webp", "images/paderewski/paderewski_6.webp", "images/paderewski/paderewski_7.webp", "images/paderewski/paderewski_8.webp", "images/paderewski/paderewski_9.webp"],
        layoutClass: "layout__paderewski",
        visualisation: "images/paderewski/paderewski_10.webp"
      },
    ];
  }

  onImageClicked(project: ArtWorkInterface): void {
    this.selectedProject = project;
    this.isModalVisible = true;
  }

  closeModal(): void {
    this.isModalVisible = false;
  }

  private sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
